module.exports = __webpack_public_path__ + "static/media/sgd-7.3352fb3b.png";